import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { ClientAddressDTO } from 'tekkeys-common';

export interface AddressesState extends EntityState<ClientAddressDTO> {}

export const addressAdapter: EntityAdapter<ClientAddressDTO> = createEntityAdapter<ClientAddressDTO>();
